import useAppleLogin from './useAppleLogin'

export default useAppleLogin
